import ds, {dsc, ___} from '../utils/daoService/DaoServiceClientES6Adapter'

const mdCodeDict = ds.QMdCodeDict.using(dsc)
mdCodeDict.queryMdCodeDict = function (params) {
    return mdCodeDict
    .select(mdCodeDict.fieldContainer())
    .where(params.whereObj)
    .paging(params.page,params.limit)
    .tag('getMdCodeDict')
    .execute()
}
export default mdCodeDict